export default "__VITE_ASSET__057f9b38__"